<template>
  <section class="store-list-drawer">
    <transition name="van-fade">
      <div v-show="show" class="mask" @click="show = false"></div>
    </transition>
    <transition name="van-slide-down">
      <main v-show="show" class="store-list" @scroll="onScroll">
        <div
          class="store-list-item"
          :class="{ active: item.storeId == storeId }"
          v-for="item in list"
          :key="item.storeId"
          @click="handleClick(item)"
        >
          <p>{{ item.storeName }}</p>
          <img
            v-show="item.storeId == storeId"
            src="@/assets/images/agent/storeTab/checked.png"
            alt=""
          />
        </div>
      </main>
    </transition>
  </section>
</template>

<script>
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'StoreListDrawer',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    storeId: {
      type: [Number, String],
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },

  setup(props, ctx) {
    const show = computed({
      get() {
        return props.modelValue
      },
      set(val) {
        ctx.emit('update:modelValue', val)
      },
    })

    const handleClick = item => {
      ctx.emit('on-change', item.storeId, item)
    }

    const onScroll = e => {
      const targetEl = e.target
      const scrollTop = targetEl.scrollTop
      const scrollHeight = targetEl.scrollHeight
      const clientHeight = targetEl.clientHeight
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        ctx.emit('on-reach-bottom')
      }
    }

    return {
      show,
      handleClick,
      onScroll,
    }
  },
})
</script>

<style lang="scss" scoped>
@import './variables.scss';

.store-list-drawer {
  .mask {
    position: fixed;
    height: calc(100vh - $tab-height);
    width: 100vw;
    top: $tab-height;
    left: 0;
    background: rgba(0, 0, 0, 0.23);
    z-index: 333;
  }

  .store-list {
    position: fixed;
    left: 0;
    top: $tab-height;
    height: 256px;
    max-height: calc(90vh - $tab-height);
    width: 100%;
    background: #fff;
    z-index: 666;
    border-radius: 0 0 20px 20px;
    overflow: auto;
  }

  .store-list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    gap: 16px;
    border-bottom: 1px solid #f5f7fa;
    p {
      flex: 1;
      font-size: 14px;
      font-size: var(--set-font-size14);
      color: #202124;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    img {
      width: 24px;
      height: 24px;
    }

    &.active {
      p {
        font-weight: bold;
      }
    }
  }
}
</style>
